export default function setProductSlider() {
  const productSlider = document.querySelectorAll('[data-product-slider]');

  if (productSlider.length > 0)
    productSlider.forEach((section) => {
      const swiper = section.querySelector('.swiper');
      const pagination = section.querySelector('.swiper-pagination');

      const sliderSectionHome = new Swiper(swiper, {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 16,
        watchOverflow: true,
        direction: 'horizontal',
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      });
    });
}
